// Sorts addresses, contacts, products and videos by their ids.
import { TProvider } from 'types';

export function sortArraysForProvider(provider: TProvider): TProvider {
  const { addresses, contacts, products, videos, ...rest } = provider;
  return {
    ...rest,
    addresses: (addresses || []).sort(sortByIndex),
    contacts: (contacts || []).sort(sortByIndex),
    products: (products || []).sort(sortByIndex),
    videos: (videos || []).sort(sortByIndex)
  };
}

function sortByIndex(a, b) {
  return a.index - b.index;
}

export type TIndexed = {
  id: number;
  index: number;
};

export function mapDraggable<T extends TIndexed>(arr: Array<T>): TIndexed[] {
  return arr.map(
    (item: T): TIndexed => ({
      id: item.id,
      index: item.index
    })
  );
}
